import styled from 'styled-components';

export const Devider = styled.hr`
  width: 100%;
  border: none;
  height: 0.1rem;
  margin-inline: 0;
  background-color: var(--color-gray2);
`;
